import React, { useEffect, useState } from 'react';
import { currency } from '@utils';
import { Button, TextInput } from '@components';
import { Formik, Field } from 'formik';
import { object, number } from 'yup';

export const SolicitacaoFormaRecebimento = ({
  dadosIniciais,
  callback,
  salvaDados,
}) => {
  const [percRenda, setPercRenda] = useState(0);
  const [simulacao, setSimulacao] = useState(false);
  const [rendaMensalInicial, setRendaMensalInicial] = useState(0);
  const valorUPF1 = 433.92;

  useEffect(() => {
    setRendaMensalInicial((dadosIniciais.reservaMatematica * percRenda) / 100);
    salvaDados({
      percRenda,
      rendaMensalInicial,
    });
    // o salvaDados da loop na aplicação como dependencia
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percRenda, dadosIniciais.reservaMatematica, rendaMensalInicial]);

  return (
    <div>
      <h2>
        <strong>Dados da nova forma de recebimento desejada</strong>
      </h2>
      <div className="row mb-2 mt-4 mb-4">
        <div className="col-12 col-md-12 col-lg-6 mt-2">
          <p className="text-orange fw-bold ts-20">Valor reserva matemática</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {currency(dadosIniciais.reservaMatematica)}
          </p>
        </div>
        {!simulacao && (
          <div className="col-12 col-md-12 col-lg-6 mt-2">
            <p className="text-orange fw-bold ts-20">Percentual de renda</p>
            <p className="text-muted fw-bold ts-18 mt-2">
              <Formik
                enableReinitialize
                initialValues={{ valorPercentualRenda: null }}
                validationSchema={object({
                  valorPercentualRenda: number()
                    .float(2, 'Máximo de duas casas decimais')
                    .typeError('Favor trocar vírgula (,) por ponto (.)')
                    .required('Insira a porcentagem')
                    .min(0.1, 'Percentual mínimo: 0,1%')
                    .max(1, 'Percentual máximo: 1%'),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  setPercRenda(values.valorPercentualRenda);
                  setSimulacao(true);
                  setSubmitting(false);
                }}
              >
                {({ handleSubmit, isSubmitting, isValid }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="d-flex col-12 col-md-12 col-lg-6">
                      <Field
                        id="valorPercentualRenda"
                        name="valorPercentualRenda"
                        placeholder="%"
                        component={TextInput}
                      />

                      <Button
                        type="submit"
                        className="ms-3"
                        disabled={isSubmitting || !isValid}
                      >
                        Simular
                      </Button>
                    </div>
                  </form>
                )}
              </Formik>
            </p>
          </div>
        )}
        {simulacao && (
          <div className="d-flex col-12 col-md-6 col-lg-4 mt-2 justify-content-end">
            <Button onClick={() => setSimulacao(false)}>
              Simular outro valor
            </Button>
          </div>
        )}
      </div>

      {simulacao && rendaMensalInicial > valorUPF1 && (
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 mt-2">
            <p className="text-orange fw-bold ts-20">
              Simulação da renda mensal inicial
            </p>
            <p className="text-muted fw-bold ts-18 mt-2">
              {currency(rendaMensalInicial)}
            </p>
          </div>
        </div>
      )}
      {simulacao && rendaMensalInicial < valorUPF1 && (
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 mt-2">
            <p className="text-orange fw-bold ts-20">
              Simulação da renda mensal inicial
            </p>
            <p className="text-red fw-bold ts-18 mt-2">
              O valor deverá ser maior que 10% da UPF1
            </p>
            <p className="text-red fw-bold ts-12 mt-2">
              Atualmente 10% da UPF1 corresponde a {currency(valorUPF1)}
            </p>
          </div>
        </div>
      )}
      <div className="row mt-32 mx-4">
        <div className="col-12 col-md-6 col-lg-8 mt-2" />
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <Button
            onClick={() => callback()}
            disabled={
              !simulacao ||
              rendaMensalInicial < valorUPF1 ||
              rendaMensalInicial === 0
            }
          >
            Solicitar
          </Button>
        </div>
      </div>
    </div>
  );
};
